import * as React from 'react';
import QuickSuggestionsFull from './components/QuickSuggestionsFull';
import isQuickSuggestionsOptionDirty from './utils/isQuickSuggestionsOptionDirty';
import discardQuickSuggestionOption from './actions/discardQuickSuggestionOption';
import saveQuickSuggestionOption from './actions/saveQuickSuggestionOption';
var QuickSuggestionsOption = {
    key: 'quickSuggestions',
    titleStringKey: 'optionTitle_quickSuggestions',
    searchTermsStringKey: 'optionTitle_quickSuggestions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(QuickSuggestionsFull, null); },
        isDirty: isQuickSuggestionsOptionDirty,
        onSave: saveQuickSuggestionOption,
        onDiscard: discardQuickSuggestionOption,
    },
};
export default QuickSuggestionsOption;
//# sourceMappingURL=QuickSuggestionsOption.js.map